import { useCallback } from 'react';
import { View } from 'react-native';

import { cartContentIdsSelector } from '../../../redux/selectors/cartContentSelector';
import { useSelector } from '../../../redux/utils';
import CheckoutItemCard from '../../CheckoutItemCard';
import FlatListWithImpression from '../../FlatListWithImpression';
import { cartContentItemProducer } from '../../FlatListWithImpression/utils';
import { styles as CartContentStyles } from '../CartContent';
import Header from './Header';

interface Props {
  isFocused: boolean;
  layoutName: string;
}

const keyExtractor = item => `${item}`;

export default ({ layoutName, isFocused }: Props) => {
  const data = useSelector(cartContentIdsSelector('outOfStock'));
  const renderItem = useCallback(
    ({ item, index }: { item: string; index: number }) => {
      const itemLength = data.length;
      const [, vid] = item.split('-');

      return (
        <>
          <CheckoutItemCard
            index={index}
            vid={vid}
            layoutName={layoutName}
            source="atcitem"
            isOutOfStock
          />
          {index < itemLength - 1 && (
            <View style={CartContentStyles.separator} />
          )}
        </>
      );
    },
    []
  );

  return (
    <FlatListWithImpression
      data={data}
      dataProducer={cartContentItemProducer}
      numColumns={1}
      layoutName={layoutName}
      keyExtractor={keyExtractor}
      renderItem={renderItem}
      ListHeaderComponent={Header}
      isFocused={isFocused}
      source="atcitem"
    />
  );
};
